export default __webpack_public_path__ + "dist/media/InviteAndTrack.6fccf434.png";